import React from "react";
import { man1, man2 } from "../../Constant/Index";
import ReUse from "../../services/helpers/reUse";
import CustomImage from "../../Components/ReUse/Components/Image";
import moment from "moment";

const StoreReveiwCard = (propsData) => {
  const {
    review_id,
    product_id,
    comment,
    rating,
    review_date,
    customer_name,
    customer_img,
    customer_desgination,
    description,
    image_path,
    customer,
    created_at
  } = propsData ?? {};

  return (
    <>
      {/* =========================== */}
      {/* Reviews-Row   */}
      <div className="row for-margin sellerstore-review">
        <div className="col-md-1">
          <div className="review-img seller-store-review-img">
            <CustomImage thumbnail={customer?.image_path} />
          </div>
        </div>
        <div className="col-md-11">
          <div className="review-tab-all">
            <div className="tab-text">
              <h5>
                {customer?.full_name}
                <span> -{moment(created_at).format(
                    "MMMM Do YYYY, h:mm a"
                  )}</span>
              </h5>
              <p>{description}</p>
            </div>
          </div>
        </div>
      </div>
      {/* =========================== */}
    </>
  );
};

export default StoreReveiwCard;
